import { swSettings } from "app/common/services/swSettings";

export const isPaidExcelAllowed = () => swSettings.components?.Home?.resources?.DaaSExcelDelivery;
